import { RouteRecordRaw } from 'vue-router'
import { ElMessage } from 'element-plus'
import store from '@/store'
import { $t } from '@/lang'
import qs from 'qs'
import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

export const filterPage = (route: string) => {
  const pageList: any[] = (store.state as any).menu.pageList
  const matchPage = pageList.find(routeItem => routeItem.route === route)
  return matchPage
}

/** 过滤路由数组菜单
 * @param {*} routes 路由数组
 */
export const filterMenuRoutes = (routes: Array<RouteRecordRaw>): Array<RouteRecordRaw> => {
  const newRoutes: Array<RouteRecordRaw> = []
  routes.forEach((route: any) => {
    if (route.children) {
      route.children = filterMenuRoutes(route.children)
    }
    route.meta.isMenu && newRoutes.push(route)
  })

  return newRoutes
}

/**
 * 下载文件
 * @param file 二进制文件流
 * @param filename 文件命名
 */
export const openFile = (file: any, filename: string) => {
  const url = window.URL.createObjectURL(
    new Blob([file.data], { type: file.headers['content-type'] })
  )
  const link = document.createElement('a')
  link.style.display = 'none'
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

/**
 * 复制文本
 * @param text 文本
 */
export const textCopy = (text: string) => {
  const tempInput = document.createElement('textarea')
  tempInput.setAttribute('id', 'cp_input')
  tempInput.value = text.trim()
  document.getElementsByTagName('body')[0].appendChild(tempInput)
  const eleInput = document.getElementById('cp_input') as HTMLInputElement
  eleInput.select()
  document.execCommand('copy')
  eleInput.remove()
  ElMessage({
    message: $t('main_request_copy_success'),
    type: 'success',
    duration: 1000,
    center: true,
    customClass: 'message-tip'
  })
}

/**
 * 防抖函数
 * @param cb 回调函数
 * @param delay 延时
 */
export const debounce = (cb: TimerHandler, delay = 300) => {
  let timer: any = null
  return function () {
    // console.log(timer)
    if (timer) {
      clearTimeout(timer)
    }
    // timer && clearTimeout(timer)
    timer = setTimeout(cb, delay)
    console.log(timer)
  }
}

/**
 * 格式化用户字符串 用户名(用户工号)
 * @param user 用户字符串
 */
export const filterUserStr = (user: string) => {
  const reg = /(.+)?(?:\(|（)(.+)(?=\)|）)/
  const r: any = reg.exec(user)
  return {
    name: r[1],
    code: r[2]
  }
}

// 判断是否为 JSON 字符串
export const isJson = (str: string) => {
  if (typeof str === 'string') {
    try {
      const obj = JSON.parse(str)
      if (typeof obj === 'object' && obj) return true
      return false
    } catch (e) {
      return false
    }
  }
}

// 格式化 JSON
export const formatJson = (json: any) => {
  let outStr = ''
  let padIdx = 0
  const space = '    '
  if (typeof json !== 'string') {
    json = JSON.stringify(json)
  }
  json = json
    .replace(/([{}[\]])/g, '\r\n$1\r\n')
    .replace(/(,)/g, '$1\r\n')
    .replace(/(\r\n\r\n)/g, '\r\n')
    .replace(/\r\n(,)\r\n/g, '$1\r\n')
  json.split('\r\n').forEach(function (node: any) {
    let indent = 0
    let padding = ''
    if (node.match(/[{[]/)) {
      indent = 1
    } else if (node.match(/[}\]]/)) {
      padIdx = padIdx !== 0 ? --padIdx : padIdx
    } else {
      indent = 0
    }
    for (let i = 0; i < padIdx; i++) {
      padding += space
    }
    outStr += padding + node + '\r\n'
    padIdx += indent
  })
  return outStr
}

/**
 * 重置 dialog data
 * @param this vue 实例
 * @param formRef 表单 ref
 * @param excluedFields 排除字段
 */
export const resetDialog = function (this: any, formRef: string, ...excluedFields: Array<any>) {
  if (formRef) {
    this.$refs[formRef].resetFields()
  }
  const obj1 = this.$data
  const obj2 = this.$options.data.call(this)
  excluedFields.push('rules')
  // if (!excluedFields || excluedFields.length === 0) {
  //   excluedFields = ['rules']
  // }
  for (const attrName in obj1) {
    if (excluedFields && excluedFields.includes(attrName)) {
      continue
    }
    obj1[attrName] = obj2[attrName]
  }
}

// 树形图过滤
export const filterTree = (name: string, value: string, data: any, node: any) => {
  const text = value.trim()
  if (!text) return true
  if (data[name].indexOf(text) !== -1) return true

  const level = node.level
  if (level === 1) return false
  let parentData = node.parent
  let index = 0
  while (index < level - 1) {
    if (parentData.data[name].indexOf(text) !== -1) return true
    parentData = parentData.parent
    index++
  }
  return false
}

// 删除确认框
export const deleteConfirm = function (
  this: any,
  title: string,
  text: string,
  callback: any,
  reload: any
) {
  this.$confirm(text, title, {
    confirmButtonText: $t('main_request_tip_confirm'),
    cancelButtonText: $t('main_request_tip_cancel'),
    type: 'danger',
    dangerouslyUseHTMLString: true,
    beforeClose: async (action: any, instance: any, done: any) => {
      if (action === 'confirm') {
        instance.confirmButtonLoading = true
        try {
          await callback()
          reload()
          ElMessage.success($t('main_request_tip_delete_success'))
        } catch (error) {
          // this.$message.error('删除失败')
          console.log(error)
        }
        instance.confirmButtonLoading = false
        done()
      } else {
        done()
      }
    }
  }).catch(() => {
    console.log()
  })
}

/**
 * url 参数过滤
 * @param url 地址
 * @param keys 过滤key
 */
export const urlQueryfilter = (url: string, keys: string[]) => {
  console.log(url)
  if (url.indexOf('?') >= 0) {
    const originPath = url.split('?')[0]
    const search = url.replace(originPath, '')
    const queryObj = qs.parse(search, { ignoreQueryPrefix: true })
    const obj: { [key: string]: any } = {}
    Object.keys(queryObj).forEach(item => {
      if (!keys.some(el => el === item)) {
        obj[item] = queryObj[item]
      }
    })
    const query = qs.stringify(obj, { addQueryPrefix: true })
    return `${originPath}${query}`
  } else {
    return url
  }
}

/**
 * encodedUrl 转义后的网址
 */
function decodeUrl(encodedUrl: string) {
  try {
    // 使用decodeURIComponent进行解码
    return decodeURIComponent(encodedUrl)
  } catch (error) {
    // 如果发生错误，可能是由于编码格式不正确
    console.error('Error decoding URL:', error)
    return null
  }
}

/**
 * url 参数过滤
 * @param url 转义后的URL地址
 * @param keys 过滤key
 */
 export const urlQueryFeishufilter = (url: string, keys: string[]) => {
  // 转义前的url
  const newUrl = decodeUrl(url)
  if (newUrl && newUrl?.indexOf('?') >= 0) {
    const urlArr = newUrl?.split('?')

    const prePath = urlArr?.[0]
    const originPath = urlArr?.[1]
    const newOri = originPath?.replace('redirect=', '')
    const search = newUrl.replace(prePath + '?' + originPath, '')
    const queryObj = qs.parse(search, { ignoreQueryPrefix: true })

    const obj: { [key: string]: any } = {}
    Object.keys(queryObj).forEach(item => {
      if (!keys.some(el => el === item)) {
        obj[item] = queryObj[item]
      }
    })
    const query = qs.stringify(obj, { addQueryPrefix: true })

    return `${newOri}${query}`
  } else {
    return url
  }
}

/**
 * @returns {string} 用户当前时区
 */
export const getTimezone = () => {
  dayjs.extend(utc)
  dayjs.extend(timezone)
  return dayjs.tz.guess() || ''
}
